import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { getRoles } from "../auth-provider/ra-auth-jwt";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

type Roles =
  | "limoome_shop.admin"
  | "limoome_shop.payment_manager"
  | "limoome_shop.partner_bundle_support";

const Dashboard = () => {
  const [roles, setRoles] = useState<Roles[]>([]);

  useEffect(() => {
    setRoles(getRoles());
  }, []);

  return (
    <Card>
      <CardContent>
        {roles.includes("limoome_shop.admin") ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              maxWidth: "680px",
            }}
          >
            {/* <div className="dashboard-card" onClick={() => window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/snapp-payment/cancel`}>
              <p style={{ fontFamily: 'IranSans-Bold' }}>عودت پرداخت اسنپ</p>
            </div> */}
            {/* <Link to={"snapp-payment/update"}>
              <div className="dashboard-card">
                <p style={{ fontFamily: "IranSans-Bold" }}>
                  مدیریت پرداخت‌های اسنپ
                </p>
              </div>
            </Link>

            <Link to={"payment-gateway-manager/update"}>
              <div className="dashboard-card">
                <p style={{ fontFamily: "IranSans-Bold" }}>
                  مدیریت درگاه پرداخت
                </p>
              </div>
            </Link> */}

            {/* ---------- */}
            <Link to={"limoocard/assign-seller"}>
              <div className="dashboard-card">
                <p style={{ fontFamily: "IranSans-Bold" }}>
                  فرم تنظیم فروشنده و بازاریاب
                </p>
              </div>
            </Link>

            <Link to={"limoocard/submit-seller-transaction"}>
              <div className="dashboard-card">
                <p style={{ fontFamily: "IranSans-Bold" }}>
                  فرم ثبت اطلاعات واریز
                </p>
              </div>
            </Link>

            <Link to={"limoocard/show-seller-info"}>
              <div className="dashboard-card">
                <p style={{ fontFamily: "IranSans-Bold" }}>
                  مشاهده اطلاعات فروش
                </p>
              </div>
            </Link>

            <Link to={"limoocard/edit-limoo-card"}>
              <div className="dashboard-card">
                <p style={{ fontFamily: "IranSans-Bold" }}>
                  ویرایش اطلاعات لیموکارت
                </p>
              </div>
            </Link>
          </div>
        ) : roles.includes("limoome_shop.payment_manager") ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              maxWidth: "680px",
            }}
          >
            {/* <div className="dashboard-card" onClick={() => window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/snapp-payment/cancel`}>
              <p style={{ fontFamily: 'IranSans-Bold' }}>عودت پرداخت اسنپ</p>
            </div> */}
            {/* <Link to={"snapp-payment/update"}>
              <div className="dashboard-card">
                <p style={{ fontFamily: "IranSans-Bold" }}>
                  مدیریت پرداخت‌های اسنپ
                </p>
              </div>
            </Link>

            <Link to={"payment-gateway-manager/update"}>
              <div className="dashboard-card">
                <p style={{ fontFamily: "IranSans-Bold" }}>
                  مدیریت درگاه پرداخت
                </p>
              </div>
            </Link> */}
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
};
export default Dashboard;
